import { render, staticRenderFns } from "./BalancePayment.vue?vue&type=template&id=604f43da&scoped=true"
import script from "./BalancePayment.vue?vue&type=script&lang=js"
export * from "./BalancePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f43da",
  null
  
)

export default component.exports